import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Email from '@material-ui/icons/MailOutline';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import Button from 'components/core/CustomButtons/Button';
import AuthField from 'components/core/AuthField';
import LoginStyle from 'assets/jss/views/LoginStyle';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import { request } from '../../request';

class ForgetPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      openSent: false,
      openEmailError: false,
    };

    this.handleEmailForgetChange = this.handleEmailForgetChange.bind(this);
    this.handleSearchTermSubmit = this.handleSearchTermSubmit.bind(this);
    this.handleClose = () => {
      this.setState({ openSent: false, openEmailError: false });
    };
  }

  handleEmailForgetChange(evt) {
    this.setState({ email: evt.target.value });
  }

  handleSearchTermSubmit(e) {
    e.preventDefault();
    const email = this.state.email;
    const url = process.env.REACT_APP_API_URL;

    request
      .POST(`${url}/v1/password/email`, {
        email,
      })
      .then(() => {
        this.setState({ openSent: true });
      });
  }

  render() {
    const { classes, onCancel } = this.props;
    return (
      <form className={classes.loginBox} onSubmit={this.handleSearchTermSubmit}>
        <p className={classes.formTitle}>استعادة كلمة المرور</p>
        <p className={classes.formSubtitle}>أدخل بريدك الإلكتروني لإرسال رابط الاستعادة</p>
        <div className={classes.fields}>
          <AuthField
            label="البريد الإلكتروني"
            id="emailForget"
            type="email"
            value={this.state.email}
            onChange={this.handleEmailForgetChange}
            autoFocus
            icon={<Email />}
          />
        </div>
        <div className={classes.submitRow}>
          <Button type="submit" color="primary" className={classes.submitBtn}>
            إرسال
          </Button>
          <Button
            type="button"
            color="secondry"
            className={classes.secondaryBtn}
            onClick={onCancel}
          >
            إلغاء
          </Button>
        </div>
        <Snackbar
          className={classes.snackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.openSent}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
            className: classes.snackbarContent,
          }}
          message={<span id="message-id">تم إرسال البريد الإلكتروني.</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
        <Snackbar
          className={classes.snackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.state.openEmailError}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'email-error-message',
            className: classes.snackbarContent,
          }}
          message={<span id="email-error-message">البريد المدخل غير صحيح.</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              className={classes.close}
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </form>
    );
  }
}

ForgetPassword.propTypes = {
  classes: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
};

export default compose(withStyles(LoginStyle))(ForgetPassword);
